import useCssVariables from 'hooks/useCssVariables';
import Header from 'sections/header';
import Navigation from 'sections/navigation';
import SubNavigation from 'sections/subNavigation';

import 'assets/styles/desktop/layout.scss';

import gitVersion from '../_git_commit';

function Layout({ children }) {
  useCssVariables();

  return (
    <>
      <Header />
      <div className="web-content-holder">
        <div className="web-content-grid">
          <div className="w-nav-box">
            <div className="w-nav-col">
              <Navigation />
            </div>
            <div className="w-sub-nav-col">
              <SubNavigation />
            </div>
            <div className="git-version">{gitVersion.logMessage}</div>
          </div>
          <div className="web-c-box">{children}</div>
        </div>
      </div>
    </>
  );
}

export default Layout;
